<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/cards' }">名片列表</el-breadcrumb-item>
            <el-breadcrumb-item>创建名片</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="120px">
            <el-form-item label="姓名">
                <el-input v-model="form.name" maxlength="150" show-word-limit/>
            </el-form-item>
            <el-form-item label="所属公司">
              <el-select
                v-model="form.company_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="getcompanylist"
                :loading="baseData.loading"
                style="width: 240px"
              >
                <el-option
                  v-for="item in baseData.companys"
                  v-ket="item.value"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="拥有者">
              <el-select
                v-model="form.member_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="getmemberlist"
                :loading="baseData.loading"
                style="width: 240px"
              >
                <el-option
                  v-for="item in baseData.members"
                  v-ket="item.value"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="名片样式">
              <el-select
                v-model="form.templet_id"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="gettempletlist"
                :loading="baseData.loading"
                style="width: 240px"
              >
                <el-option
                  v-for="item in baseData.templets"
                  v-ket="item.value"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form :model="form" :inline="true" label-width="120px">
                <el-form-item label="展示图">
                    <el-row class="martop">
                        <el-upload
                        class="avatar-uploader"
                        action=""
                        :http-request="uploadLogo"
                        :show-file-list="false"
                        >
                        <img v-if="form.img" :src="form.img" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                        <template #tip>
                            <div class="el-upload__tip">
                            请上传jpg/png的统一尺寸图片，图片比例为1:1，<br>
                            推荐尺寸：200px*200px,图片大小不能大于2M
                            </div>
                        </template>
                        </el-upload>
                    </el-row>
                </el-form-item>
            </el-form>
            <el-form :model="form" :inline="true" label-width="120px">
                <el-form-item label="职位">
                    <el-input v-model="form.position" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="公司电话">
                    <el-input v-model="form.phone" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="座机">
                  <el-input v-model="form.landline" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="form.email" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="微信号">
                  <el-input v-model="form.wxcode" maxlength="150" show-word-limit/>
                </el-form-item>
                <el-form-item label="标签" style="width: 100%">
                  <el-input v-model="form.labels" maxlength="250" show-word-limit/>
                </el-form-item>
                <el-form-item label="地址" style="width: 100%">
                    <el-input v-model="form.address" maxlength="250" show-word-limit/>
                </el-form-item>
                <el-form-item label="简介" style="width: 100%">
                  <el-input v-model="form.introduction" maxlength="350" show-word-limit/>
                </el-form-item>
                <el-form-item label="展示图">
                  <el-upload
                      v-model:file-list="form.imglist"
                      action=""
                      :http-request="uploadImgList"
                      list-type="picture-card"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                  >
                      <el-icon><Plus /></el-icon>
                      <template #tip>
                          <div class="el-upload__tip">
                            请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M
                          </div>
                        </template>
                  </el-upload>
      
                  <el-dialog v-model="dialogVisible">
                      <img w-full :src="dialogImageUrl" alt="Preview Image" />
                  </el-dialog>
              </el-form-item>
            </el-form>
            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio label="0">冻结</el-radio>
                    <el-radio label="1">待绑定</el-radio>
                    <el-radio label="2">正常</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">返回</el-button>
            </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { cardApi } from '@/api/card'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  const router = useRouter()
  const route = useRoute()
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  const baseData:any = reactive({
    loading:false,
    members:[],
    templets:[],
    companys:[],
  })
  const form:any = reactive({
    id: '',
    member_id: '',
    templet_id: '',
    company_id: '',
    img:'',
    name: '',
    position: '',
    phone: '',
    landline: '',
    email: '',
    wxcode: '',
    labels: '',
    address: '',
    introduction: '',
    imglist:[],
    status: '2',
  })
  const getcompanylist = (words:any) =>{
    baseData.loading = true
    api.companyApi.list({page:1,limit:100,words:words}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        let companys:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            companys.push({
              value: item.id,
              label: item.title
            })
          })
        }
        
        baseData.companys = companys
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const gettempletlist = (words:any) =>{
    baseData.loading = true
    api.cardApi.templetlist({page:1,limit:100,words:words}).then((res:any)=>{
      if(res.code==200){
        baseData.loading = false
        let templets:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            templets.push({
              value: item.id,
              label: item.title
            })
          })
        }
        
        baseData.templets = templets
     }else{
        ElMessage.error(res.message)
     }
    })
  }
  const getmemberlist = (words:any) =>{
    baseData.loading = true
    api.memberApi.list({page:1,limit:100,words:words}).then((res:any)=>{
      if(res.code==200){
        baseData.loading = false
        baseData.members.length = 0
        let members:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            members.push({
              value: item.id,
              label: item.nickname
            })
          })
        }
        
        baseData.members = members
     }else{
        ElMessage.error(res.message)
     }
    })
  }
  const uploadImgList = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
          let data:any = {name:file.name,url:res.data.img}
          form.imglist.pop()
          form.imglist.push(data);
        }
    })
  }
  const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!
    dialogVisible.value = true
  }
  const onSubmit = () => {
    let data = {...form};
    const loading = ElLoading.service({lock: true})
    data.imglist = form.imglist ? JSON.stringify(form.imglist) : ""
    api.cardApi.add(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/cards");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const uploadLogo = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('展示图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  onMounted(()=>{
    getmemberlist('')
    gettempletlist('')
    getcompanylist('')
  })
  </script>